import React, { useCallback, useMemo, useState } from "react";
import { resetPass } from "../store/auth/AuthActions.js";
import { useDispatch } from "react-redux";
import logoUrl from "img/zeta-logo.png";
import { useParams } from "react-router";
import { Links } from "./Links.jsx";


export const ResetForm = () => {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [password, setPassword] = useState("");

    const dispatch = useDispatch();

    const params = useParams();
    const onSubmit = useCallback((e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        dispatch(resetPass(password, params.token)).then(() => {
            setLoading(false)
            location.href = "/#/";
        }, (e) => {
            setLoading(false);
            setError(e.toString());
        })
    }, [password, params.token])

    const { sub: subName } = useMemo(() => JSON.parse(atob(params.token.split(".")[1])), [ params.token ])

    let body = null;

    if(loading){
        body = (<div id="loading-display">
            <p><i className="fa fa-spinner fa-pulse fa-2x"></i></p>
            <h2>Signing in...</h2>
        </div>);
    }else{
        body = (
            <div id="login-form">
                <p className="form-control-static">{subName}</p>
                <label htmlFor="inputPassword" className="sr-only">Password</label>
                <input value={password} onChange={ev => setPassword(ev.target.value)} type="password" id="inputPassword" minLength={8} className="form-control" placeholder="Password" required />
                <div id="button-box">
                    <button type="submit" className="btn btn-lg btn-primary btn-block" id="signin" >Reset Password</button>
                    <a href="#/" className="btn btn-lg btn-block" id="register">Cancel</a>
                    <a href="#/help">Help</a>
                </div>
            </div>
        );
    }

    return (
        <form className="form-signin" id="login" onSubmit={onSubmit}>
            <img className="zeta-logo" src={logoUrl} />
            <h3>Reset Password</h3>
            {error ?
                <div className="alert alert-danger" role="alert" id="error-message">Reset failed: {error}</div>
                :
                null
            }
            {body}
            <Links/>
        </form>
    )
}